import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';

import { editContributionStateWhenMasterAction } from './contributionActions';

import DoneIcon from '@material-ui/icons/Done';
import PendingIcon from '@material-ui/icons/TouchApp';
import UnknownIcon from '@material-ui/icons/Update';
import RejectedIcon from '@material-ui/icons/Clear';

const styles = theme => ({
  form: {
    display: 'flex',
    alignItems: 'center',
    width: 83
  },
  button: {
    display: 'block',
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    marginLeft: 0
  },
  unknownIcon: {
    margin: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2 + 10,
    color: 'grey',
    border: '2px solid grey',
    borderRadius: '30%',
    padding: 5,
    boxShadow: '2px 2px 5px grey'
    //marginLeft: 10,
    //margin: 15
  },
  formControl: {
    margin: theme.spacing.unit,
    width: 0
    //minWidth: 120
    //visibility: 'hidden',
    //height: 0
  }
});

const renderIconButton = state => {
  switch (state) {
    case 'approved':
      return (
        <DoneIcon
          style={{
            color: 'green',
            border: '2px solid green',
            borderRadius: '50%',
            padding: 5,
            boxShadow: '1px 1px 5px grey',
            marginLeft: 10
          }}
        />
      );
    case 'rejected':
      return (
        <RejectedIcon
          style={{
            color: 'red',
            border: '2px solid red',
            borderRadius: '30%',
            padding: 5,
            boxShadow: '2px 2px 5px grey',
            marginLeft: 10
          }}
        />
      );
    case 'pending_review':
      return (
        <PendingIcon
          style={{
            color: 'orange',
            border: '2px solid orange',
            borderRadius: '30%',
            padding: 5,
            marginLeft: 10,
            boxShadow: '2px 2px 5px grey'
          }}
        />
      );
    default:
      return 'Error';
  }
};

class MasterContributionIcons extends React.Component {
  state = {
    //age: '',
    open: false
  };

  handleChange = (event, record, missionId) => {
    const { value: newState } = event.target;
    const { id: contributionId } = record;

    this.props.editContributionStateWhenMasterAction(
      missionId,
      contributionId,
      newState
    );
    //thissetState({ [event.target.name]: event.target.value });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  render() {
    const { classes, record, missionId, translate } = this.props;
    const { state } = record;
    const stateValue = record.state ? state : 'undefinedState';

    console.warn('prooopppsss', this.props);

    return stateValue !== 'undefinedState' ? (
      <form className={classes.form} autoComplete="off">
        <Button className={classes.button} onClick={this.handleOpen}>
          {renderIconButton(state, classes)}
        </Button>
        <FormControl className={classes.formControl}>
          <Select
            style={{ visibility: 'hidden' }}
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={stateValue}
            onChange={event => this.handleChange(event, record, missionId)}
            inputProps={{
              name: 'status',
              id: 'demo-controlled-open-select'
            }}
          >
            <MenuItem value={'pending_review'}>
              {translate('contributions.pending')}
            </MenuItem>
            <MenuItem value={'approved'}>
              {translate('contributions.approved')}
            </MenuItem>
            <MenuItem value={'rejected'}>
              {translate('contributions.rejected')}
            </MenuItem>
          </Select>
        </FormControl>
      </form>
    ) : (
      <UnknownIcon className={classes.unknownIcon} />
    );
  }
}

MasterContributionIcons.propTypes = {
  classes: PropTypes.object.isRequired
};

MasterContributionIcons = withStyles(styles)(MasterContributionIcons);

export default connect(
  null,
  { editContributionStateWhenMasterAction }
)(MasterContributionIcons);



// WEBPACK FOOTER //
// ./src/contributions/MasterContributionIcons.js